<template>
    <main id="login" class="w-100 h-100">
        <div class="d-flex justify-content-center">
            <div
                class="content d-flex flex-column justify-content-center align-items-center"
                style="width: 45%; margin-top: 50px; transition: 1s all"
            >
                <div class="content-form" style="width: 60%">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <img src="https://static.supsis.live/common/supsisAiLogo.png" style="width: 150px" />
                        <language-switch />
                    </div>
                    <div style="margin-top: 50px; color: #183b56; font-weight: 700; font-size: 35px">
                        <div style="line-height: 1">{{ $t("login.emailLogin") }}</div>
                    </div>
                    <div style="margin-top: 40px">
                        <div>
                            <span class="font-weight-bold" style="color: #183b56">{{ $t("login.email") }}</span>
                            <div style="margin-top: 3px">
                                <a-form-item
                                    has-feedback
                                    :validate-status="
                                        email ? (!!errors.first('email') ? 'error' : 'success') : undefined
                                    "
                                    :help="email && errors.first('email') ? $t('login.emailError') : undefined"
                                >
                                    <a-input
                                        ref="userNameInput"
                                        v-model="email"
                                        v-validate="'required|email'"
                                        name="email"
                                        :class="{ error: !!errors.first('email') }"
                                        :placeholder="$t('login.emailPlaceholder')"
                                    >
                                        <a-icon slot="prefix" type="mail" />
                                    </a-input>
                                </a-form-item>
                            </div>
                        </div>
                        <div :id="recaptchaContainerId" style="margin-top: 20px"></div>
                        <div class="d-flex justify-content-between" style="margin-top: 20px">
                            <div
                                class="text-center w-100 text-white font-weight-bold user-select-none"
                                style="border-radius: 8px; padding: 13px 0; font-size: 15px"
                                :style="{
                                    background: email ? '#ec4b1d' : '#C3CAD9',
                                    cursor: email ? 'pointer' : null,
                                }"
                                @click="email ? submit() : null"
                            >
                                {{ $t("login.passwordLogin") }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" style="margin-top: 20px">
                            <hr color="#C3CAD9" width="50%" />
                            <div style="margin: 0px 5px; color: #183b56" width="100%">{{ $t("login.loginAnd") }}</div>
                            <hr color="#C3CAD9" width="50%" />
                        </div>
                        <div class="d-flex justify-content-between w-100" style="margin-top: 20px">
                            <router-link
                                to="/login"
                                class="w-100 text-white text-center font-weight-bold"
                                style="background: #183b56; border-radius: 8px; padding: 13px 0; font-size: 15px"
                            >
                                {{ $t("login.passwordAndLogin") }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";
import LanguageSwitch from "../../components/LanguageSwitch";
import SupsisLogo from "../../components/svg/SupsisLogo.vue";
import { getInvisibleRecaptchaToken, hideRecaptchaBadge, renderRecaptcha, resetRecaptcha } from "../../utils/recaptcha";
import CONFIG from "../../config/config";

export default {
    name: "PasswordlessLogin",
    components: { PasswordForgot, LanguageSwitch, SupsisLogo },

    data() {
        return {
            loading: false,
            isSubmit: false,
            email: "",
            recaptchaSiteKey: CONFIG.RECAPTCHA.SITE_KEY,
            recaptchaContainerId: "passwordless-login-recaptcha",
        };
    },
    mounted() {
        this.renderRecaptcha();
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
        }),
    },
    beforeDestroy() {
        hideRecaptchaBadge();
    },
    methods: {
        ...mapActions({
            passwordlessLoginRequest: "auth/passwordlessLoginRequest",
        }),
        getRecaptchaToken() {
            return getInvisibleRecaptchaToken(this.recaptchaSiteKey, this.recaptchaContainerId);
        },
        renderRecaptcha() {
            renderRecaptcha(this.recaptchaSiteKey, this.recaptchaContainerId, "PASSWORDLESS_LOGIN");
        },
        submit() {
            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    this.getRecaptchaToken().then((recaptchaToken) => {
                        if (!recaptchaToken) {
                            this.$bvToast.toast("Lütfen güvenlik doğrulamasını tamamlayın.", {
                                title: this.$t("message.error"),
                                variant: "danger",
                                solid: true,
                            });
                            this.loading = false;
                            return;
                        }
                        this.passwordlessLoginRequest({ email: this.email, recaptchaToken })
                            .then((z) => {
                                this.$bvToast.toast(this.$t("message.forgetPasswordSent"), {
                                    title: this.$t("message.successful"),
                                    variant: "success",
                                    duration: 50000,
                                    solid: true,
                                });
                                setTimeout(() => {
                                    this.$router.push("login");
                                }, 6000);
                            })
                            .catch((error) => {
                                if (error.response.data.localizedMessages) {
                                    this.$bvToast.toast(
                                        this.language.code === "en"
                                            ? error.response.data.localizedMessages.en
                                            : error.response.data.localizedMessages.tr,
                                        {
                                            title: this.$t("message.error"),
                                            variant: "danger",
                                            solid: true,
                                        }
                                    );
                                } else {
                                    console.error("error --> ", error);
                                    this.$bvToast.toast(error.response.data, {
                                        title: error.response.statusText || "Error",
                                        variant: "danger",
                                        solid: true,
                                    });
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                                resetRecaptcha(this.recaptchaSiteKey, this.recaptchaContainerId);
                            });
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
::-moz-selection {
    /* Code for Firefox */
    color: white !important;
    background: #ec4b1d !important;
}

::selection {
    color: white !important;
    background: #ec4b1d !important;
}

@media (max-width: 724px) {
    .content-form {
        width: 80% !important;
    }
}

@media (max-width: 950px) {
    .user-hash {
        flex-direction: row;
    }

    .content {
        flex-direction: row;
        width: 100% !important;
    }

    .right-side {
        display: none !important;
    }
}
</style>
